// theme/assets/brands-page.js
(function () {
  if (window.__TFS_BRANDS_PAGE__) return; window.__TFS_BRANDS_PAGE__ = true;
  var root = document.querySelector('.tfs-brands'); if (!root) return;
  var catalog = root.getAttribute('data-catalog') || 'wheels';
  var grid = root.querySelector('[data-brands-grid]');
  var cfg = window.__TFS_FITMENT_CONFIG__ || {};
  var apiUrl = cfg.apiUrl || '';

  function applyFit(vehicleId, label) {
    if (!vehicleId) { showAll(); return; }
    fetch(apiUrl + '/api/fitment/brands?catalog=' + catalog + '&vehicleId=' + encodeURIComponent(vehicleId))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.success) return;
        var fit = {}; d.brands.forEach(function (b) { fit[b.name] = b.count; });
        var shown = 0;
        grid.querySelectorAll('.tfs-brands__card').forEach(function (a) {
          var name = a.getAttribute('data-vendor');
          if (fit[name] != null) { a.style.display = ''; shown++; var c = a.querySelector('.tfs-brands__count'); if (c) c.textContent = fit[name] + ' that fit'; }
          else { a.style.display = 'none'; }
        });
        setBanner(shown + ' ' + catalog + ' brands fit your ' + (label || 'vehicle'));
      });
  }
  function showAll() {
    grid.querySelectorAll('.tfs-brands__card').forEach(function (a) { a.style.display = ''; });
    setBanner('');
  }
  function setBanner(text) {
    var bar = root.querySelector('[data-brands-fitbar]'); if (!bar) return;
    bar.textContent = text; bar.style.display = text ? 'block' : 'none';
  }

  function bind(fitment) {
    var v = fitment.getVehicle();
    if (v && (v.vehicleId || v.id)) applyFit(v.vehicleId || v.id, fitment.formatVehicle ? fitment.formatVehicle(v) : '');
    fitment.on('vehicle-changed', function (veh) { applyFit(veh && (veh.vehicleId || veh.id), fitment.formatVehicle ? fitment.formatVehicle(veh) : ''); });
    fitment.on('vehicle-cleared', showAll);
  }
  if (window.TFSFitment) bind(window.TFSFitment);
  else document.addEventListener('tfs-fitment-ready', function () { if (window.TFSFitment) bind(window.TFSFitment); }, { once: true });
})();
